<template>
  <div class="hero-area hero-area-two">
    <Swiper
      :modules="modules"
      :slides-per-view="1"
      :speed="1500"
      :loop="true"
      :autoplay="{
        delay: 2500,
        disableOnInteraction: false,
      }"
      :pagination="{ clickable: true }"
      class="homepage-slides"
      id="homepage-slides"
    >
      <SwiperSlide class="single-slide-item">
        <div
          class="slider-bg bg-cover"
          data-background="/assets/img/slider/slide-4.jpg"
        >
          <div class="overlay-2"></div>
          <div class="container">
            <div class="hero-area-content">
              <h3>Your Partner in Compliance & Financial Growth</h3>
              <h1 class="text-white">Expert Tax Services <br />in UAE</h1>
              <p class="text-white">
                Helping businesses stay fully compliant while achieving financial clarity and growth. 
                Expert solutions in Corporate Tax, VAT, Accounting, and Business Advisory services with 
                deep understanding of UAE tax laws and regulatory frameworks.
              </p>
              <router-link class="main-btn" :to="{ name: 'Contact' }"
                >Get Started Today</router-link
              >
            </div>
            <div class="social-link">
              <a href="#">.FACEBOOK</a>
              <a href="#">.LINKEDIN</a>
              <a href="#">.INSTAGRAM</a>
              <a href="#">.WHATSAPP</a>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide class="single-slide-item">
        <div
          class="slider-bg bg-cover"
          data-background="/assets/img/slider/slide-2.jpg"
        >
          <div class="overlay-2"></div>
          <div class="container">
            <div class="hero-area-content">
              <h3>Your Partner in Compliance & Financial Growth</h3>
              <h1 class="text-white">VAT & Compliance <br />Dubai</h1>
              <p class="text-white">
                Helping businesses stay fully compliant while achieving financial clarity and growth. 
                Expert solutions in Corporate Tax, VAT, Accounting, and Business Advisory services with 
                deep understanding of UAE tax laws and regulatory frameworks.
              </p>
              <router-link class="main-btn" :to="{ name: 'Contact' }"
                >Get Started Today</router-link
              >
            </div>
            <div class="social-link">
              <a href="#">.FACEBOOK</a>
              <a href="#">.LINKEDIN</a>
              <a href="#">.INSTAGRAM</a>
              <a href="#">.WHATSAPP</a>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide class="single-slide-item">
        <div
          class="slider-bg bg-cover"
          data-background="/assets/img/slider/slide-4.jpg"
        >
          <div class="overlay-2"></div>
          <div class="container">
            <div class="hero-area-content">
              <h3>Your Partner in Compliance & Financial Growth</h3>
              <h1 class="text-white">Accounting & Tax <br />Comply</h1>
              <p class="text-white">
                Helping businesses stay fully compliant while achieving financial clarity and growth. 
                Expert solutions in Corporate Tax, VAT, Accounting, and Business Advisory services with 
                deep understanding of UAE tax laws and regulatory frameworks.
              </p>
              <router-link class="main-btn" :to="{ name: 'Contact' }"
                >Get Started Today</router-link
              >
            </div>
            <div class="social-link">
              <a href="#">.FACEBOOK</a>
              <a href="#">.LINKEDIN</a>
              <a href="#">.INSTAGRAM</a>
              <a href="#">.WHATSAPP</a>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div class="founder-year">
      <h2>Afino Tax</h2>
      <RouterLink :to="{ name: 'Contact' }">Contact With Us</RouterLink>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default {
  name: "HeroArea2",
  components: { Swiper, SwiperSlide },
  data() {
    return {
      modules: [Pagination, Autoplay],
    };
  },
  mounted() {},
};
</script>
